


export const projectsData = [
    {
        id: 1,
        projectName: 'Unifeed blog',
        projectDesc: 'Built a codewell challenge static site responsively with html/css',
        tags: ['HTML' ,'CSS'],
        code: 'https://github.com/misathemeb/misathemeb.github.io/tree/main/Unifeed_blog_1.12.22',
        demo: 'https://misathemeb.github.io/Unifeed_blog_1.12.22/index.html',
        image: "https://user-images.githubusercontent.com/91221861/169353770-e7281639-3a7d-4c1c-94bb-7c1898d2c6b4.png"
    },
    {
        id: 2,
        projectName: 'Jammming playlist generator',
        projectDesc: 'This is a playlist creation app utilizing React & Spotify API implicit grant flow',
        tags: ['HTML', 'CSS','React',],
        code: 'https://github.com/misathemeb/jammming',
        demo: 'https://github.com/misathemeb/jammming/tree/main/jammming-fe/src',
        image: "https://user-images.githubusercontent.com/91221861/173615525-25448204-c42a-412e-9759-be0cfb1a6844.png"
    },
    {
        id: 3,
        projectName: 'Hosterr landing page',
        projectDesc: 'This project is a codewell challenge to practice CSS layout and form fields',
        tags: ['HTML', 'CSS'],
        code: 'https://github.com/misathemeb/misathemeb.github.io/tree/main/Hosterr%20site%2011.29.21/Design',
        demo: 'https://misathemeb.github.io/Hosterr%20site%2011.29.21/Design/hosterr.html',
        image: "https://user-images.githubusercontent.com/91221861/166805198-6d7f067f-b39c-402d-9bac-053e39349c71.png"
    },
    {
        id: 4,
        projectName: 'Appointment planner',
        projectDesc: 'This is a project I made on the Codecademy front-end engineer career path with React stateful and stateless components using React hooks.',
        tags: ['React', 'HTML', 'CSS'],
        code: 'https://github.com/misathemeb/Appointment-Planner',
        demo: 'https://react-appt-planner.netlify.app/',
        image: "https://user-images.githubusercontent.com/91221861/173641298-006f24a3-c9f3-460c-9b02-6a9bec93c66e.png"
    },
    // {
    //     id: 5,
    //     projectName: 'Countries',
    //     projectDesc: 'This project is a fullstack app inspired by a FrontEndMentor challenge.',
    //     tags: ['HTML', 'CSS', 'React', 'JSX'],
    //     code: 'https://github.com/misathemeb/rest-countries',
    //     demo: 'https://github.com/misathemeb/rest-countries',
    //     image: ""
    // },
    {
        id: 6,
        projectName: 'Todo App',
        projectDesc: 'This is a CRUD app utilizing React custom hooks',
        tags: ['HTML', 'CSS','Javascript', 'React'],
        code: 'https://github.com/misathemeb/todo-custom-hooks',
        demo: 'https://todo-reacthooks.netlify.app/',
        image: "https://user-images.githubusercontent.com/91221861/177183022-2b9644cf-01f4-4885-ace1-f717c730b479.png"
    },
    
    
    
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/